import { makeStyles } from 'tss-react/mui'
import { lato } from '@styles/fonts'
import { nunito_sans } from '@styles/fonts'
import ReportAbuseInsta from 'src/assets/images/report/reportAbuseInsta.jpg'
import MobileArrow from 'src/assets/images/report/mobileArrow.png'

const useStyles = makeStyles()((theme) => ({
  outerContainer: {
    height: 'auto',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
  },

  innerContainer: {
    maxWidth: theme.maxWidth,
    padding: theme.spacing(40, 16, 30),

    margin: 'auto',
    height: 'auto',
    backgroundImage: `url(${ReportAbuseInsta?.src})`,
    backgroundRepeat: 'no-repeat',
    borderRadius: '60px',
    backgroundPosition: 'center',
    backgroundSize: 'cover',

    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(15, 5),
      borderRadius: '30px',
    },
  },

  title: {
    fontFamily: nunito_sans.style.fontFamily,
    fontStyle: 'normal',
    fontWeight: 800,
    fontSize: '64px',
    textAlign: 'center',
    lineHeight: '72px',
    textTransform: 'uppercase',
    color: theme.custom.whiteColor,
    margin: 'auto',
    [theme.breakpoints.down('md')]: {
      fontSize: '34px',
      lineHeight: '46px',
      padding: theme.spacing(12, 0, 0),
    },
  },
  desc: {
    fontFamily: lato.style.fontFamily,
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '20px',
    textAlign: 'center',
    lineHeight: '24px',
    color: theme.custom.whiteColor,
    padding: theme.spacing(6, 0, 0),
    margin: 'auto',
    opacity: '.7',
    width: '55%',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      fontSize: '14px',
      textAlign: 'center',
      lineHeight: '17px',
    },
  },

  sponsorBox: {
    width: '216px',
    // height: ' 160.5px',
    margin: 'auto',
    textAlign: 'center',
    // background:
    //   'linear-gradient(106.87deg, #DC86A0 2.25%, #A0C0E9 28.43%, #EAA539 54.12%, #848CC9 81.29%, #63D169 97.09%)',
    position: 'relative',
    zIndex: '996',

    [theme.breakpoints.down('sm')]: {
      width: '170px',
      height: ' 220.5px',
      background: `url(${MobileArrow?.src})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: '100% 100%',
      marginBottom: '-3.7rem',
      position: 'relative',
      zIndex: '2',
      img: {
        width: '127px',
      },
    },
  },

  sponsoredBy: {
    fontFamily: nunito_sans.style.fontFamily,
    fontStyle: 'normal',
    fontWeight: 800,
    fontSize: '20px',
    textAlign: 'center',
    lineHeight: 'normal',
    textTransform: 'uppercase',
    color: theme.custom.whiteColor,
    padding: theme.spacing(10, 0, 0),
    [theme.breakpoints.down('sm')]: {
      fontSize: '18px',
      padding: theme.spacing(10, 0, 0),
    },
  },
  learnMoreBtn: {
    background: 'black',
    color: 'white',
    textAlign: 'center',
    '&:hover': {
      background: 'white',
      color: 'black',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      flex: 1,
    },
  },
  btnWrapper: {
    width: 'fit-content !important',
    margin: 'auto',
    marginTop: theme.spacing(8),
  },
  descWrapper: {
    maxWidth: theme.maxWidth,
    '@media (min-width:1920px)': {
      padding: theme.spacing(0, 16, 0),
    },
  },

  zenBrand: {
    background: '#1c1c1c',
  },
  zenBg: {
    backgroundImage: `url('')`,
    border: '1px solid black',
  },

  zenColor: {
    color: theme.custom.blackColor,
  },
}))

export default useStyles
